import "./GetAQuote.module.css";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import ProductHeroSection from "./sections/ProductHeroSection";
import LeadForm from "./sections/LeadForm";
import ContactDetailsCommitment from "./sections/ContactDetailsCommitment";
export default function GetAQuotePage() {
  return <div>
      <Header />
      <ProductHeroSection />
      <LeadForm />
      <ContactDetailsCommitment />
      <Footer />
    </div>;
}